<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main">
        <SubTitleComponent :title="title" :type="''"></SubTitleComponent>
        <div class="box">
          <el-table
            :data="customerData.filter(data => !searchValue || data.name.toLowerCase().includes(searchValue.toLowerCase()))"
            style="width: 100%"
            stripe>
            <el-table-column
              label="客户名称"
              prop="client_name">
            </el-table-column>
            <el-table-column
              label="客户类型"
              prop="industry_type">
            </el-table-column>
            <el-table-column
              align="right">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="searchValue"
                  placeholder="输入关键字搜索"/>
              </template>
              <template slot-scope="scope">
                <el-button
                  @click="toDetail(scope.$index, scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>
let _ajaxType = 0

export default {
  name: 'CustomerHistory',
  components: {},
  data() {
    return {
      title: '历史客户',
      customerData: [],
      searchValue: '',
      page: 0,
      pagesize: 10,
      allpage: 0
    }
  },
  mounted() {
    _ajaxType = 0
    this.load()
  },
  methods: {
    toDetail(index, row) {
      console.log(index, row.history_client_id);
      this.$router.push({ path: '/customerhistorydetail/' + row.history_client_id })
    },
    load () {
      this.getData()
    },
    getData() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _url = "/api/?mod=history_client"
        let _clientData = {
          page: _page + 1,
          pagesize: this.pagesize,
          keyword: this.searchValue
        }
        // console.log(this.axios)
        this.axios.post(_url, _clientData).then(json => {
          _ajaxType = 0
          // 获取
          let _data = json.data.data
          console.log("clientData", _data);
          if (json.data.errcode == 0) {
            this.page = _data.page
            this.allpage = _data.allpage
            this.customerData = [...this.customerData, ..._data.result]
          }
          console.log(json.data);
        })
      }
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .filter {
      margin-bottom: 20px;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
      .el-button {
        width: 100%;
      }
    }
    ul.list {
      display: grid;
      // flex-wrap: wrap;
      // justify-content: space-between;
      grid-template-columns: repeat(3, 1fr);
      padding-inline-start: 0;
      gap: 20px;
      // padding: 0 30px;
      vertical-align: top;
      list-style: none;
      li {
        position: relative;
        // flex: 0 0 calc(30%);
        gap: 20px;
        padding: 5px 10px 10px;
        background: #fff;
        border: 1px dashed rgb(187, 187, 187);
        border-radius: 5px;
        box-sizing: border-box;
        .id {
          color: rgba(101,103,104,1);
          font-size: 12px;
          line-height: 24px;
        }
        .name {
          color: rgba(10,10,10,1);
          font-size: 18px;
          line-height: 36px;
        }
        .info {
          min-height: 48px;
          margin-bottom: 12px;
          vertical-align: top;
          font-size: 0;
          span {
            display: inline-block;
            margin-right: 15px;
            color: rgba(101,103,104,1);
            font-size: 12px;
            font-weight: 300;
            line-height: 24px;
          }
        }
        .date {
          color: rgba(101,103,104,1);
          font-size: 12px;
          line-height: 24px;
        }
        .detail {
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/CustomerHistory/Index.vue